import { useState } from 'react';

import useAsyncEffect from 'components/modules/foundation/hooks/use-async-effect';

import API from '../../../../libs/api';

export function useQuestionGroups(merchantProduct) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  async function refreshGroups() {
    setLoading(true);
    try {
      const data = await API.getQuestionGroups({ merchantProduct: merchantProduct.id });
      setGroups(data);
    } finally {
      setLoading(false);
    }
  }

  useAsyncEffect(async () => {
    await refreshGroups();
  }, []);

  async function createGroup(groupData) {
    setLoading(true);
    try {
      const newGroup = await API.createQuestionGroup({
        ...groupData,
        merchantProduct: merchantProduct.id,
      });
      setGroups((prev) => [...prev, newGroup]);
    } finally {
      setLoading(false);
    }
  }

  async function updateGroup(groupId, groupData) {
    setLoading(true);
    try {
      const updated = await API.updateQuestionGroup(groupId, groupData);
      setGroups((prev) => prev.map((g) => (g.id === groupId ? updated : g)));
    } finally {
      setLoading(false);
    }
  }

  async function deleteGroup(groupId) {
    setLoading(true);
    try {
      await API.deleteQuestionGroup(groupId);
      setGroups((prev) => prev.filter((g) => g.id !== groupId));
    } finally {
      setLoading(false);
    }
  }

  const groupOperations = {
    createGroup,
    updateGroup,
    deleteGroup,
    refreshGroups,
  };

  return {
    groups,
    loading,
    setGroups,
    groupOperations,
    ...groupOperations,
  };
}
